var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.106 1.747A1.246 1.246 0 0 1 7.25 1h11.5a1.25 1.25 0 0 1 .919 2.097l-4.67 5.075V13a.999.999 0 0 1-1.6.8l-2-1.5a.993.993 0 0 1-.4-.8V8.172L6.332 3.097a1.254 1.254 0 0 1-.225-1.35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.25 3h3.878c.1.281.256.544.465.772L10 8.562v.522l-1 1.088V14a.999.999 0 0 1-1.6.8l-2-1.5a.993.993 0 0 1-.4-.8v-2.328L.33 5.097a1.248 1.248 0 0 1-.225-1.35C.306 3.29.753 3 1.25 3Z",
  opacity: 0.4
})));
export default SvgFilterIcon;